import { render, staticRenderFns } from "./chut.vue?vue&type=template&id=9044eb84&scoped=true&"
import script from "./chut.vue?vue&type=script&lang=js&"
export * from "./chut.vue?vue&type=script&lang=js&"
import style0 from "./chut.vue?vue&type=style&index=0&id=9044eb84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9044eb84",
  null
  
)

export default component.exports